/**
 * Check if a value is empty, whitespace-only, or a dash placeholder
 * @param value - The string value to check
 * @returns true if the value is empty, whitespace, or a dash (— or –)
 */
export const isEmpty = (value: string | undefined): boolean => {
  return !value || value.trim() === '' || value === '—' || value === '–';
};

/**
 * Check if a string is a valid 4-digit year (e.g. "2024")
 * @param yearStr - The string to validate
 * @returns true if the string is exactly 4 digits
 */
export const isValidYear = (
  yearStr: string | undefined | null,
): yearStr is string => {
  return !!yearStr && /^\d{4}$/.test(yearStr);
};
